module.exports = __webpack_public_path__ + "static/media/akatva.c9a97222.jpeg";